import React from "react";
import {
	BaseContainer,
	BaseText,
	BaseAddress,
	BaseContactInfo,
} from "../../../../../../components";
import { OrderContentSection } from "../../../index";
// TYPES
import { OrderDetailsContentProps } from "../../types";
const OrderDetailsContentSection: React.FC<OrderDetailsContentProps> = ({
	orderDetails,
	fields,
	hostName,
	currencyCharacter,
}) => {
	// CLASSES:
	const orderDetailsSectionClasses =
		"flex pb-5 max-xl:grid gap-5 max-xl:grid-cols-2 max-xl:gap-8 max-md:grid-cols-1 max-md:gap-2 ";
	const orderDetailsBaseContainerClasses =
		"flex flex-col items-start w-1/6 grow max-xl:w-[90%] py-2.5 px-3 max-xl:mx-6 max-xl:my-6 max-sm:mx-0";
	const shipToBaseContainerClasses =
		"flex flex-col items-start w-1/4 grow max-xl:w-[90%] py-2.5 px-3 max-xl:mx-6 max-xl:my-6 max-sm:mx-0";
	const billToBaseContainerClasses =
		"flex flex-col items-start w-1/4 grow max-xl:w-[90%] py-2.5 px-3 max-xl:mx-6 max-xl:my-6 max-sm:mx-0";
	const orderSummaryBaseContainerClasses =
		"flex flex-col items-start w-1/6 grow max-xl:w-[90%] py-2.5 px-3 max-xl:mx-6 max-xl:my-2 max-sm:mx-0";
	const individualSectionContainerClasses =
		"flex flex-col items-start w-full h-full";

	return (
		<div className="">
			<section className={orderDetailsSectionClasses}>
				<BaseContainer
					columnContainerClasses={orderDetailsBaseContainerClasses}
					columnShape="semi-rounded"
					borderColor="navy-200"
					backgroundColor="bg-navy-50"
					isDisabled={false}
					children={
						<>
							<OrderContentSection
								data={orderDetails}
								currencyCharacter={currencyCharacter}
								hostName={hostName}
								sectionContainerClasses="flex flex-col items-start h-full w-full"
								detailsContainerClasses="w-full pt-3"
								dataLabel="ORDERDETAILS"
								fields={
									fields?.DUMMYORDERDETAILSFIELDS[0]
										?.ORDERDETAILS
								}
								isDisabled={false}
								valueType={"detail"}
								sectionTitle={
									<BaseText
										size={"text-sm"}
										color={"text-navy-500"}
										text={
											fields?.labels
												?.orderDetailsSectionTitle
										}
										fontFamily={"font-omnes-medium"}
										tag={"h2"}
									/>
								}
							/>
						</>
					}
				/>
				<BaseContainer
					columnContainerClasses={shipToBaseContainerClasses}
					columnShape="semi-rounded"
					borderColor="navy-200"
					backgroundColor="bg-navy-50"
					isDisabled={false}
					children={
						<>
							<OrderContentSection
								currencyCharacter={currencyCharacter}
								sectionContainerClasses="flex flex-col items-start"
								detailsContainerClasses="w-full pt-3"
								hostName={hostName}
								sectionTitle={
									<BaseText
										size={"text-sm"}
										color={"text-navy-500"}
										text={
											fields?.labels?.shipToSectionTitle
										}
										fontFamily={"font-omnes-medium"}
										tag={"h2"}
									/>
								}
								children={
									<>
										<BaseContactInfo
											contactData={orderDetails?.contact}
										/>
										<BaseAddress
											title={
												<BaseText
													text={
														fields?.labels
															?.locationLabel
													}
													size={"text-sm"}
													color={"text-navy-500"}
													tag={"h2"}
													fontFamily={
														"font-omnes-medium"
													}
												/>
											}
											addressLines={[
												orderDetails?.shipToAddress
													?.addressee ?? "",
												orderDetails?.shipToAddress
													?.attention
													? `${fields?.labels?.attentionPrefix} ${orderDetails?.shipToAddress.attention}`
													: "",

												orderDetails?.shipToAddress
													?.line1 ?? "",
												orderDetails?.shipToAddress
													?.line2 ?? "",
												`${
													orderDetails?.shipToAddress
														?.city ?? ""
												}, ${
													orderDetails?.shipToAddress
														?.state?.code ?? ""
												} ${
													orderDetails?.shipToAddress
														?.zip ?? ""
												}`,
												orderDetails?.shipToAddress
													?.phoneNumber ?? "",
											]}
											additionalClasses="pt-3"
										/>
										<div className="text-sm text-navy-500 flex flex-col items-start mt-2">
											<span className=" font-omnes-medium">
												{
													fields?.labels
														?.shippingMethodLabel
												}
											</span>
											<span className="font-omnes-regular">
												<span className="font-omnes-regular">
													{orderDetails
														?.shippingMethod?.name
														? orderDetails
																.shippingMethod
																?.name
														: "—"}
												</span>
											</span>
										</div>
									</>
								}
							/>
						</>
					}
				/>
				<BaseContainer
					columnContainerClasses={billToBaseContainerClasses}
					columnShape="semi-rounded"
					borderColor="navy-200"
					backgroundColor="bg-navy-50"
					isDisabled={false}
					children={
						<>
							<OrderContentSection
								sectionContainerClasses={
									individualSectionContainerClasses
								}
								currencyCharacter={currencyCharacter}
								detailsContainerClasses="w-full pt-3"
								hostName={hostName}
								sectionTitle={
									<BaseText
										size={"text-sm"}
										color={"text-navy-500"}
										text={
											fields?.labels?.billToSectionTitle
										}
										fontFamily={"font-omnes-medium"}
										tag={"h2"}
									/>
								}
								children={
									<>
										<BaseContactInfo
											contactData={orderDetails?.contact}
										/>
										<BaseAddress
											title={
												<BaseText
													text={
														fields?.labels
															?.locationLabel
													}
													size={"text-sm"}
													color={"text-navy-500"}
													tag={"h2"}
													fontFamily={
														"font-omnes-medium"
													}
												/>
											}
											addressLines={[
												orderDetails?.shipToAddress
													?.addressee ?? "",
												orderDetails?.shipToAddress
													?.attention
													? `${fields?.labels?.attentionPrefix} ${orderDetails?.shipToAddress.attention}`
													: "",
												orderDetails?.shipToAddress
													?.line1 ?? "",
												orderDetails?.shipToAddress
													?.line2 ?? "",
												`${
													orderDetails?.shipToAddress
														?.city ?? ""
												}, ${
													orderDetails?.shipToAddress
														?.state?.code ?? ""
												} ${
													orderDetails?.shipToAddress
														?.zip ?? ""
												}`,
												orderDetails?.shipToAddress
													?.phoneNumber ?? "",
											]}
											additionalClasses="pt-3"
										/>
									</>
								}
							/>
						</>
					}
				/>
				{hostName !== "PRUDENTIAL" && (
					<BaseContainer
						columnContainerClasses={
							orderSummaryBaseContainerClasses
						}
						columnShape="semi-rounded"
						borderColor="none"
						backgroundColor=""
						isDisabled={false}
						children={
							<>
								<OrderContentSection
									currencyCharacter={currencyCharacter}
									data={orderDetails}
									hostName={hostName}
									dataLabel={"ORDERSUMMARY"}
									valueType={"detail"}
									detailsContainerClasses="w-full pt-3"
									sectionContainerClasses={`${individualSectionContainerClasses} mb-10`}
									fields={
										fields?.DUMMYORDERDETAILSFIELDS[2]
											.ORDERSUMMARY
									}
									isDisabled={false}
									sectionTitle={
										<BaseText
											size={"text-sm"}
											color={"text-navy-500"}
											text={
												fields?.labels
													?.orderSummarySectionTitle
											}
											fontFamily={"font-omnes-medium"}
											tag={"h2"}
										/>
									}
								/>
								{orderDetails._totalLease !== "0.00" &&
									hostName === "COMPASS" && (
										<OrderContentSection
											currencyCharacter={
												currencyCharacter
											}
											data={orderDetails}
											hostName={hostName}
											dataLabel={"RECURRINGCHARGES"}
											valueType={"detail"}
											detailsContainerClasses="w-full"
											sectionContainerClasses={
												individualSectionContainerClasses
											}
											fields={
												fields
													?.DUMMYORDERDETAILSFIELDS[3]
													.RECURRINGCHARGES
											}
											isDisabled={false}
											sectionTitle={
												<BaseText
													size={"text-sm"}
													color={"text-navy-500"}
													text={
														fields?.labels
															?.recurringChargesSectionTitle
													}
													fontFamily={
														"font-omnes-medium"
													}
													tag={"h2"}
												/>
											}
										/>
									)}
							</>
						}
					/>
				)}
			</section>
		</div>
	);
};

export default OrderDetailsContentSection;
